// ModalVerFormas.jsx
import { message, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import verFormasPdf from "../../../../Pdf/verFormasPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalVerFormas extends Component {
  state = {
    loading: false,
    pdf: null,
    datos: null, // respuesta base del API (codigoBarras, descripcion, unidad)
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.consultarTodo();
    }
  }

  async consultarTodo() {
    this.setState({ loading: true, pdf: null });
    try {
      const res = await axios.post(
        "insumos/datosVerFormas", // <-- tu endpoint (mantengo el de tu ejemplo)
        { insumoId: this.props.insumoId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      if (res.data?.success === 2) {

        const dd = verFormasPdf(res.data);
        const pdf = pdfMake.createPdf(dd);

        this.setState(
          { loading: false, pdf, datos: res.data },
          () => pdf.open({}, window.frames["verFormasPdf"])
        );
      } else {
        message.warning("No se encontraron datos para generar el pdf.");
        this.setState({ loading: false, pdf: null, datos: null });
      }
    } catch (e) {
      console.error(e);
      message.error("Error al consultar datos para el pdf.");
      this.setState({ loading: false, pdf: null, datos: null });
    }
  }

  cerrar = () => {
    this.props.cerrarModalVerFormas?.();
  };

  render() {
    const { visible } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title="Ver Formas"
        visible={visible}
        spinning={loading}
        onCancel={this.cerrar}
        paddingTop
      >
        <Space direction="vertical" style={{ width: "100%" }} size="small">

          {/* Visor PDF */}
          <iframe
            title="verFormasPdf"
            id="verFormasPdf"
            name="verFormasPdf"
            style={{ width: "100%", height: "70vh", border: "1px solid #eee", borderRadius: 6 }}
          />
        </Space>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalVerFormas);
